import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "content-body mt-3 d-flex flex-column justify-content-start align-content-start px-3" }
const _hoisted_2 = { class: "text-start mb-3" }
const _hoisted_3 = { class: "fs-4 fw-bold content-title" }
const _hoisted_4 = { class: "row row-cols-1" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "d-flex mb-2 pl-2 justify-content-end"
}
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "align-self-end" }
const _hoisted_12 = { class: "demo-pagination-block mt-3 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Operation = _resolveComponent("Operation")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t("search_for_kaizen_strategy")), 1)
    ]),
    _createVNode(_component_el_form, {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
      class: "mt-2",
      "label-position": 'right',
      "label-width": 'auto'
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('form.label.period')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.searchCriteria.lastPeriodCnt,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchCriteria.lastPeriodCnt) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("last_1_period")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("last_2_period")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 4 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("last_4_period")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 6 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("last_6_period")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 10 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("last_10_period")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('form.label.manufacture_method')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  class: "w-100",
                  modelValue: _ctx.isCheckAll,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCheckAll) = $event)),
                  indeterminate: _ctx.isIndeterminate,
                  onChange: _ctx.onCheckAllChanged
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("select_all")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "indeterminate", "onChange"]),
                _createVNode(_component_el_checkbox_group, {
                  class: "row row-cols-6",
                  modelValue: _ctx.searchCriteria.manufMethodIds,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchCriteria.manufMethodIds) = $event)),
                  onChange: _ctx.onManufMethodCheckChanged
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manufMethodList, (manufMethod) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: manufMethod.id,
                        label: manufMethod.id,
                        name: "method"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(manufMethod.methodName), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_button, {
        type: "",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onBtnClearSearchClicked()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("clear")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onBtnSearchTableListClicked()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("search")), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_8,
    (_ctx.userInfoStore.permissions.some(x=> [220].includes(x)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_el_button, {
            onClick: _ctx.onExportReportClicked,
            disabled: _ctx.displayList.length == 0
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("export")), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_popover, {
          placement: "bottom",
          onHide: _ctx.onColDisplayCtrlPanelHidded,
          trigger: "click",
          Title: _ctx.t('column')
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, { link: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { size: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Operation)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[0],
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.colDisplayCtrl[0]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("period")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[1],
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.colDisplayCtrl[1]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("site")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[2],
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.colDisplayCtrl[2]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("WFS")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[3],
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.colDisplayCtrl[3]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Kaizen")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[4],
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.colDisplayCtrl[4]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Kaizen_Plan")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[5],
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.colDisplayCtrl[5]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Kaizen_Content")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["onHide", "Title"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        class: "w-100",
        data: _ctx.displayList,
        stripe: true,
        onSortChange: _ctx.onSortChanged
      }, {
        default: _withCtx(() => [
          (_ctx.colDisplayCtrl[0])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                width: "60",
                prop: "periodNum",
                label: _ctx.t('period')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[1])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                width: "80",
                prop: "siteName",
                label: _ctx.t('site')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[2])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                "min-width": "120",
                prop: "manufMethodName",
                label: _ctx.t('WFS')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[3])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 3,
                "min-width": "120",
                prop: "impPlan",
                label: _ctx.t('Kaizen')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[4])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 4,
                "min-width": "120",
                prop: "impMethod",
                label: _ctx.t('Kaizen_Plan')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[5])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 5,
                "min-width": "120",
                prop: "impMethodDetail",
                label: _ctx.t('Kaizen_Content')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data", "onSortChange"])), [
        [
          _directive_loading,
          _ctx.isTableLoading,
          void 0,
          {
            fullscreen: true,
            lock: true
          }
        ]
      ])
    ]),
    _createVNode(_component_el_row, {
      justify: "end",
      class: "mt-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_pagination, {
                currentPage: _ctx.searchCriteria.page,
                "onUpdate:currentPage": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.searchCriteria.page) = $event)),
                "page-size": _ctx.searchCriteria.pageSize,
                "onUpdate:page-size": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.searchCriteria.pageSize) = $event)),
                "pager-count": _ctx.paginatorSetup.pagerCount,
                layout: _ctx.paginatorSetup.layout,
                small: _ctx.paginatorSetup.small,
                "page-sizes": [20, 50, 100],
                total: _ctx.filteredTotal,
                onSizeChange: _ctx.onPagesizeChanged,
                onCurrentChange: _ctx.onCurrentPageChanged,
                justify: "end"
              }, null, 8, ["currentPage", "page-size", "pager-count", "layout", "small", "total", "onSizeChange", "onCurrentChange"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ])), [
    [
      _directive_loading,
      _ctx.isPageLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}